import { createContext, useContext } from "react";

import type { ApiResponse } from "@fleet/api";

type ParkInfoResponse = ApiResponse<"/fleet-forms/selfreg/v1/park/info", "GET">;

const ParkInfoContext = createContext<ParkInfoResponse | undefined>(undefined);

export const ParkInfoContextProvider = ParkInfoContext.Provider;

export const useParkInfoContext = () => {
  return useContext(ParkInfoContext);
};
